import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'

import { Login, Logout } from './components/Login'
import Placement from './components/Placement'
import Campaign from './components/Campaign'
import Brand from './components/Brand'
import Portal from './components/Portal'
import Questionnaire from './components/Questionnaire'
import { defaultLink } from './utils/consts';
import ModalsManager, { ModalManagerContext } from './components/ModalsManager';
import CreateCampaign from './components/Campaign/CreateCampaign';
import EditCampaign from './components/Campaign/EditCampaign';
import Network from './components/Network';
import Analytics from './components/Analytics';
import Download from './components/Download';
import LegalText from './components/LegalText'
import { withAuthentication } from './components/common/Session';

import './i18n'

function App() {
  const modalsController = React.createRef();
  const openModal = (Content, onConfirm, additionalData, overrideClassName) => {
    if (!modalsController.current) return;
    modalsController.current.open(Content, onConfirm, additionalData, overrideClassName)
  }

  return (
    <React.Fragment>
      <ModalsManager ref={modalsController} />
      <ModalManagerContext.Provider value={openModal}>
        <Router>
          <Switch>
            <Route
              path="/login"
              component={Login}
            />
            <Route
              path="/logout"
              component={Logout}
            />
            {/* <Route
              path="/register"
              component={Register}
            /> */}
            <Route
              path="/placements"
              component={Placement}
            />
            <Route
              path="/campaigns/new"
              component={CreateCampaign}
            />
            <Route
              path="/campaigns/edit/:id"
              component={EditCampaign}
            />
            <Route
              path="/campaigns"
              component={Campaign}
            />
            <Route
              path="/portal/create"
              render={() => <Portal create />}
            />
            <Route
              path="/portal"
              component={Portal}
            />
            <Route
              path="/network"
              component={Network}
            />
            <Route
              path="/analytics"
              component={Analytics}
            />
            <Route
              path="/questionnaire"
              component={Questionnaire}
            />
            <Route
              path="/download"
              component={Download}
            />
            <Route
              path="/brand/create"
              render={() => <Brand newBrand />}
            />
            {/* <Route
              path="/brand/edit"
              render={() => <Brand newBrand={false} />}
            /> */}

            <Route path="/legal-text" component={LegalText} />
            {/* <Route
              path="/user"
              component={User}
            /> */}
            <Route render={() => <Redirect to={defaultLink} />} />
          </Switch>
        </Router>
      </ModalManagerContext.Provider>
    </React.Fragment>
  )
}

export default withAuthentication(App)
